import { render, staticRenderFns } from "./BenefitLogActionChip.vue?vue&type=template&id=007a58f1"
import script from "./BenefitLogActionChip.vue?vue&type=script&lang=js"
export * from "./BenefitLogActionChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports